import latestVersion from './latestVersion/latest-version-list';
import drawerMenuData from './drawerMenu/drawer-menu-list'
import bannerData from './Banner/banner-list'
import selectItemDrawerMenuReducer from './slices/selectItemDrawerMenu'
import productData from './ProductList/product-list'
import colorData from './ColorList/color-list'
import selectColor from "./slices/selectColor";
import spaceData from "./SpaceList/space-list";
import selectSpace from "./slices/selectSpace";
import searchInputReducer from "./slices/searchInputSlice";
import selectProductIdReducer from './slices/selectProductId'
import productModalData from './ProductModalData/product-modal-data-list'
import showMoreProductData from './ShowMoreProduct/show-more-product-list'
import {combineReducers} from "@reduxjs/toolkit";
import currentPageReducer from './slices/currentPageSlice'
import loadingReducer from './slices/loadingSlice';
import totalCountReducer from './slices/totalCountSlice';
import freeCheckboxReducer from './slices/freeCheckboxSlice';
import licenceReducer from "./Licence/licence";
import licenceValueSlice from "./slices/licenceValueSlice";
import likeReducer from './LikeForm/like-form'
import likeFormIdSlice from "./slices/likeFormIdSlice";
import dislikeReducer from "./DislikeForm/dislike-form";
import showMoreCollectionData from './ShowMoreCollection/show-more-collection-list';
import likeCollectionReducer from './LikeCollection/like-collection'
import likeCollectionIdSlice from './slices/likeCollectionIdSlice'
import dislikeCollectionReducer from './DislikeCollection/dislike-collection';
import collectionModalDataReducer from './CollectionModalData/collection-modal-data-list';
import collectionModalData from './CollectionModalData/collection-modal-data-list'
import likeStatusSlice from './slices/likeStatus'
import licenceData from './Licence/licence'
import isLoginReducer from './slices/isLoginSlice'
import isLoginModalOpenReducer from './slices/isLoginModalOpenSlice'
import signUpReducer from './slices/signUpSlice'
import signUpContentReducer from './slices/signUpContents'
import signUpErrorMessageReducer from './slices/signUpErrorMessage'
import signInErrorMessageReducer from './slices/signInErrorMessage'
import signInContentReducer from './slices/signInContents'
import initialize from './auth/initialize'
import collectionNameReducer from './slices/collectionNameSlice'
import bannerReducer from './SingleCollectionBanner/reducer'
import profileReducer from './Profile/reducer';
import singleCollectionCategoryFileReducer from './SingleCollectionCategory/reducer';
import favoriteFilesReducer from './FavoriteFiles/reeducer';
import favoriteCollectionReducer from './FavoriteCollection/reducer';
import activeLicenseReducer from './ActiveLicense/reducer';
import forgetPasswordReducer from './ForgetPassword/reducer';
import showmoreStatusCode from "./slices/showmoreStatusCode";


const reducers = {
    initialize,
    latestVersion,
    drawerMenuData,
    selectItemDrawerMenu: selectItemDrawerMenuReducer,
    bannerData,
    productData,
    colorData,
    selectColor,
    spaceData,
    selectSpace,
    searchInputContent: searchInputReducer,
    selectProductId: selectProductIdReducer,
    productModalData,
    showMoreProductData,
    currentPage:currentPageReducer,
    loading: loadingReducer,
    totalCount: totalCountReducer,
    freeCheckbox:freeCheckboxReducer,
    licenceReducer,
    licenceValue:licenceValueSlice,
    likeReducer,
    likeFormId:likeFormIdSlice,
    dislikeReducer,
    showMoreCollectionData,
    likeCollectionReducer,
    likeCollectionId:likeCollectionIdSlice,
    dislikeCollectionReducer,
    collectionModalDataReducer,
    collectionModalData,
    likeStatus:likeStatusSlice,
    licenceData,
    isLogin:isLoginReducer,
    isLoginModalOpen:isLoginModalOpenReducer,
    signUp:signUpReducer,
    signUpContent:signUpContentReducer,
    signUpErrorMessage:signUpErrorMessageReducer,
    signInErrorMessage:signInErrorMessageReducer,
    signInContent:signInContentReducer,
    collectionName:collectionNameReducer,
    banner: bannerReducer,
    profile:profileReducer,
    singleCategoryFile:singleCollectionCategoryFileReducer,
    favoriteFiles:favoriteFilesReducer,
    favoriteCollection:favoriteCollectionReducer,
    activeLicense:activeLicenseReducer,
    forgetPassword:forgetPasswordReducer,
    showmoreStatusCode

};

export default reducers;
